import { Box } from "@mui/system";
import BrandsDateFilter from "./BrandsContent/BrandsDateFilter";
import BrandsSearchFilter from "./BrandsContent/BrandsSearchFilter";
import BrandsSearchItems from "./BrandsContent/BrandsSearchItems";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { buiDashboardEndPointLogicMobile } from "../../../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboardMobile/buiDashboardEndPointLogicMobile";
import {
  performaceLastRunQueryIdBrand,
  performaceQueryIdBrand,
} from "../../../helpers/QIDs";
import { setBrandsFetchedKey } from "../../../../../../../../features/businessLeaderDashboardSlice";
import BrandSkeleton from "../../../helpers/BrandSkeleton";
import { getDateRange } from "../../../helpers/getDateRangeforBrands";
import store from "../../../../../../../../store";
type SortConfig = {
  field: string | null;
  direction: "asc" | "desc";
};
const Brands = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [searchParams, setSearchParams] = useSearchParams();
  const websiteSharedUids = searchParams.get("workspace");
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    field: "reg",
    direction: "desc",
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { brandsFetchedKey } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );
  const initialDate = searchParams.get("dateForBrands") || "MTD";
  const [dateType, setDateType] = useState(initialDate);
  const initialSearch = searchParams.get("searchBrandForBrands");
  const [searchValue, setSearchValue] = useState<string | null>(initialSearch);

  useEffect(() => {
    const current = searchParams.get("searchBrandForBrands");
    if (searchValue === current) return;
    const next = new URLSearchParams(searchParams);
    if (searchValue) {
      next.set("searchBrandForBrands", searchValue);
    } else {
      next.delete("searchBrandForBrands");
    }
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line
  }, [searchValue]);

  useEffect(() => {
    const current = searchParams.get("dateForBrands");
    if (current === dateType) return;
    const next = new URLSearchParams(searchParams);
    if (dateType) {
      next.set("dateForBrands", dateType);
    } else {
      next.delete("dateForBrands");
    }
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line
  }, [dateType]);

  useEffect(() => {
    const currentDate = searchParams.get("dateForBrands");
    if (!currentDate) {
      return;
    }
    const fetchKey = `${websiteSharedUids}-${dateType}`;
    if (!oauthTokenHeader || !websiteSharedUids) return;
    if (brandsFetchedKey === fetchKey) return;
    const { start_date, end_date } = getDateRange(dateType);
    const fetchData = async () => {
      try {
        setLoading(true);
        const dimensionResponse =
          await buiDashboardEndPointLogicMobile.getDimensionInBizLeaderDashboardMobile(
            oauthTokenHeader,
          );
        if (!dimensionResponse || dimensionResponse.status !== 200) {
          return;
        }
        const dimensions = dimensionResponse?.data?.data || [];
        const matchedDimensions = dimensions
          ?.filter((dim: any) =>
            dim.websites?.some(
              (site: any) => site.shared_uid === websiteSharedUids,
            ),
          )
          ?.map((dim: any) => dim.dimension);
        const dimensionsToUse =
          matchedDimensions?.length > 0
            ? matchedDimensions
            : dimensions?.length > 0
              ? [dimensions[0].dimension]
              : [];

        if (!dimensionsToUse?.length) return;
        if (!start_date || !end_date) {
          store.dispatch(
            setDisplayErrorSnackBar({
              message: "Date range is not valid",
              type: "error",
            }),
          );
          setLoading(false);
          return;
        }
        if (!websiteSharedUids) {
          store.dispatch(
            setDisplayErrorSnackBar({
              message: "Website shared uid is not valid",
              type: "error",
            }),
          );
          setLoading(false);
          return;
        }
        await Promise.all([
          buiDashboardEndPointLogicMobile.getBrandPerformanceQueryInBizLeaderDashboardMobile(
            {
              oauthTokenHeader,
              queryId: performaceQueryIdBrand,
              websiteSharedUids: websiteSharedUids?.split(",") || [],
              type: "site",
              dimension: dimensionsToUse || [],
              start_date, // Pass empty string or valid date if needed
              end_date, // Pass empty string or valid date if needed
            },
          ),
          buiDashboardEndPointLogicMobile.getBrandPerformanceLastRunQueryInBizLeaderDashboardMobile(
            {
              oauthTokenHeader,
              queryId: performaceLastRunQueryIdBrand,
              websiteSharedUids: websiteSharedUids?.split(",") || [],
              type: "site",
              dimension: dimensionsToUse || [],
            },
          ),
        ]);
        dispatch(setBrandsFetchedKey(fetchKey));
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteSharedUids]);
  return (
    <>
      <Box sx={{ px: 2 }}>
        <BrandsDateFilter
          value={dateType}
          onChange={setDateType}
          loading={loading}
        />
        {loading ? (
          <BrandSkeleton />
        ) : (
          <>
            <BrandsSearchFilter
              value={searchValue}
              onChange={setSearchValue}
              sortConfig={sortConfig}
              setSortConfig={setSortConfig}
            />
            <BrandsSearchItems
              searchValue={searchValue}
              sortConfig={sortConfig}
            />
          </>
        )}
      </Box>
    </>
  );
};

export default Brands;
